/**
 * Created by Claude on 03.03.2026
 */

cleverapps.override(cleverapps.EVENTS, {
    AUTO_ORDER: "auto_order",
    MERGE_BONUS: "merge_bonus",
    THIRD_EL_BONUS: "thirdel_bonus",
    LUCKY_DROP: "lucky_drop",
    OPEN_STAGE: "open_stage",
    PASS_ALL_SIDEQUESTS: "pass_all_sidequests",

    BOOSTER_USE: "booster_use",
    BOOSTER_USE_DAU: "booster_use_dau",
    BOOSTER_RECEIVE: "booster_receive",
    BOOSTER_RECEIVE_DAU: "booster_receive_dau",
    ENERGY_BOOSTER_BONUS: "energy_booster_bonus",

    EARN: {
        UNITS_SHOP: "units_shop"
    }
});